import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { customerLogin as apiLogin, setToken, clearToken, getCustomerProfile } from '../services/customerService';

interface CustomerUser { id: string; email: string; full_name: string; client_id: string; }
interface CustomerAuthState { user: CustomerUser | null; loading: boolean; error: string | null; login: (email: string, password: string) => Promise<void>; logout: () => void; }

const Ctx = createContext<CustomerAuthState | null>(null);

export function CustomerAuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<CustomerUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('nexus_token');
    if (!token) { setLoading(false); return; }
    getCustomerProfile().then((p: any) => setUser(p.user)).catch(() => clearToken()).finally(() => setLoading(false));
  }, []);

  const login = async (email: string, password: string) => {
    setError(null);
    const data = await apiLogin(email, password);
    setToken(data.token);
    setUser(data.user);
  };

  const logout = () => { clearToken(); setUser(null); };

  return <Ctx.Provider value={{ user, loading, error, login, logout }}>{children}</Ctx.Provider>;
}

export function useCustomerAuth() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useCustomerAuth must be inside CustomerAuthProvider');
  return ctx;
}
